module.exports = __webpack_public_path__ + "static/media/orange-bg-portrait.b3f7731c.webp";